import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { alertActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AgencyCreate from "../../components/AgencyCreate";
import ManageAgencyTable from "../../components/AgencyTable";
import { ERR_MSG } from "constants/labels";
import {
  createMapRequestorApi,
  deleteMapRequestorApi,
  getMapRequestorsApi,
  updateMapRequestorApi,
} from "services/mapCenter/mapCenter.thunks";
import { MAP_REQUESTOR_FIELD_MAPPING } from "../../utils";

const ManageMapRequestor = () => {
  const header = "Manage Map Requestor";
  const dispatch = useDispatch();
  const [rawTableData, setRawTableData] = useState([]);

  const fetchRequestors = async () => {
    try {
      const res = await dispatch(getMapRequestorsApi()).unwrap();
      if (!res || !res?.Succeeded) {
        dispatch(
          alertActions.error({
            message: res?.Message || ERR_MSG["073"],
            header,
          }),
        );
        return;
      }
      setRawTableData(res?.Data || []);
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header,
        }),
      );
    }
  };

  useEffect(() => {
    fetchRequestors();
  }, []);

  return (
    <>
      <Typography component="div" className="userprofilelist">
        <Grid container direction="row" spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>
            <Typography variant="h2" className="userprofilelistcontent">
              {header}
            </Typography>
          </Grid>
        </Grid>
      </Typography>
      <Grid container justifyContent={"flex-end"} alignItems={"center"}>
        {rawTableData && (
          <AgencyCreate
            agencies={rawTableData}
            handleRefresh={fetchRequestors}
            createApi={createMapRequestorApi}
            header={header}
            title="Create Map Requestor"
            buttonLabel="Requestor"
            fieldMapping={MAP_REQUESTOR_FIELD_MAPPING}
            portalID={3}
          />
        )}
      </Grid>
      <Typography component="div">
        {rawTableData && (
          <ManageAgencyTable
            portalID={3}
            rawTableData={rawTableData}
            handleRefresh={fetchRequestors}
            updateApi={updateMapRequestorApi}
            deleteApi={deleteMapRequestorApi}
            header={header}
            emptyMessage="No Map requestor data found."
            fieldMapping={MAP_REQUESTOR_FIELD_MAPPING}    
            deleteMessage="Are you sure, you want to delete selected Map Requestor?"
            deleteMessageBulk="Are you sure, you want to delete selected Map Requestor/s?"
          />
        )}
      </Typography>
    </>
  );
};

export default ManageMapRequestor;
